import { IChatsData, IConversationData } from 'services/api/chat';
import { IUploadFileOutput } from 'services/api/file';

export const Topics = {
  MessageAdd: (roomId: string) => `messageAdd_${roomId}`,
  Chat: (roomId: string) => `chat_${roomId}`,
  MessageRemove: 'messageRemove',
  MemberChats: 'memberChats',
  // Online: 'online',
  ChatNotifications: 'ChatNotifications',
  UnreadChats: 'UnreadChats',
};

export enum ChatEvents {
  JoinChatGroup = 'joinChatGroup',
  AddChatMessage = 'addChatMessage',
  RemoveChatMessage = 'removeChatMessage',
  LeaveChatGroup = 'leaveChatGroup',
  ViewChatGroup = 'viewChatGroup',
  ReadChatgroup = 'readChatGroup',
}

export interface IChatSocketMessageAdd {
  chatGroupGuid: string;
  message: string;
  type: MessageType;
}

export enum MessageType {
  text = 1,
  image = 2,
  link = 3,
  video = 4,
  voice = 5,
}

export interface IUploadFile {
  onSuccess: (response: IUploadFileOutput) => void;
}

export interface IChatSocketMessageRemove {
  chatGroupGuid: string;
  messageId: number;
}

export interface IChatSocketReadChat {
  chatGroupGuid: string;
}

export interface IJoinChatGroupData {
  chatGroupGuid: string;
}

export interface IUnreadConversationsData {
  count: number;
}

export interface IChatOnlineMembersChat {
  sessionId: string;
  onlineMembers: number;
}

export interface IChatData extends Partial<IChatsData['items'][0]> {
  onlineMembers?: number;
  chatMembers?: Array<{
    id?: number;
    guid?: any;
    chatid?: number;
    entityid?: number | null;
    entityname?: string;
    params?: string;
    status?: number;
    createdat?: Date;
    role?: number;
    read?: boolean;
    membername?: string;
  }>;
}

export enum ChatStatus {
  Active = 1,
  Mute = 2,
  Deleted = 3,
}

export enum ChatType {
  Personal = 1,
  Group = 2,
}

export enum ChatEntityStatus {
  Active = 1,
  Inactive = 2,
}

export enum ChatEntityRoles {
  Admin = 1,
  Simple = 2,
}

export type IMessageItem = IConversationData['items'][0];

export type IMessageAddData = IMessageItem & {
  chatGuid: string;
  senderName: string | null;
  senderId: number;
  virtualpath: string;
};
